import axios from "axios";
// import authHeader from "@/services/auth-header";
import config from "@/data/config";

const API_URL = config.baseURL;

export const landing = {
   namespaced: true,
   state: {
      status: {
         total: {
            umat: 0,
            kk: 0,
            baptis: 0,
            komuni: 0,
            krisma: 0,
            perkawinan: 0,
         },
         total_year: {
            baptis: 0,
            komuni: 0,
            krisma: 0,
            perkawinan: 0,
         },
      },
      chart: {
         baptis: {
            labels: [2017, 2018, 2019, 2020, 2021],
            series: [10, 59, 80, 81, 56, 55, 40],
         },
      },
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getAll({ commit, rootState }) {
         rootState.isLoading = true;
         return await axios
            .get(`${API_URL}api/landing`)
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.status = data;
         state.chart.baptis = data.baptis_chart;
      },
   },
};
